import { ADD_MANUAL_PRICING, ADD_MANUAL_PRICING_SUCCESS, ADD_MANUAL_PRICING_ERROR, ADD_MANUAL_PRICING_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const AddManualPricing = (state = initialState, action) => {
  switch (action.type) {
    case ADD_MANUAL_PRICING:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case ADD_MANUAL_PRICING_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case ADD_MANUAL_PRICING_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case ADD_MANUAL_PRICING_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default AddManualPricing;
